import React from 'react';

export default function Blog015() {
  return (
    <section>
    <article>
      <h2>15. 09-16-2022</h2>
      <h3>Bootstrap and Creating Tutorials</h3>
      <p> I have imported REACT and tested the initial start file. I am excited to say that I am going to learn Bootstrap before I learn React.
       This was my origonal order of operation and I would like to keep on track with my goals. So, to be clear: I am not creating bootstrap tutorials. 
       I am learning Bootstrap, and creating a tutorial series on the HTML basics. Let's talk about both of these.
       <br />
       <br />
       <strong>Bootstrap</strong>
       <br />
       Bootstrap is a bit easier to wield than I had anticipated. I enjoy creating html using Bootstrap, as it does make things much faster to put together.
      Link the Bootstrap CSS and JS file, and you are ready to start using Bootstrap. Add a class to an tag and watch Bootstrap go!
      I enjoy the simple-step process required to access and utilize Bootstrap. I can see myself using Bootstrap in combination with my own CSS 'default' file to
      create a plethora of web applications. I would like to create my own default CSS file to add additional background and text colors, attributes, and animation.
      <br />
      I am practicing Bootstrap without tutorials by creating a simplified 'Dungeons and Dragons' inspired game. I have currently created half of the 
      game playing material. I plan on creating a landing page to link together all of the playing material involved and releasing the game to print and play for free. 
      <br />
      <br />
      <strong>Creating Tutorials</strong>
      <br />
      The concept of creating a tutorial is not new for me. I have been a freelance animator for years and have created multiple tutorials in several genres 
      including but not limited to animation, video editing, 3d modeling, game design, and programming. I have decided to created a tutorial series based on 
      a time limit, <br /> with a title like "Create ______ in 80 seconds!". <br /> This rather simple to do while creating a simple web page for the first video. Though I am 
      sure as the topics become more complex I will have a much more difficult experience crunching everything into a minute 20 seconds. <br />
      As for the first video in the series, you can check it out now on my website, or youtube. The link is below. 
      <br />
      <br /><br />
      I enjoy creating tutorials, and I find it to be a fun way of demonstrating the knowledge I have obtained. I am going to continue to focus on learning 
      Javascript and Bootstrap while creating tutorials as a secondary priority. The end goal is to give real world examples of my skill level and ability to work. 

      </p>
    </article>

    <h4>Links</h4>
    <br />
    <ul>
      <li>
        <a
          href="https://www.youtube.com/watch?v=J6aWT0ywgWE&list=PLce5_YZyrUw6mOXubpKKWoTROUqCfIDDo"
          title="Tutorial"
          target="_blank"
          rel="noopener noreferrer" 
        >
          <strong><p>Make your first website in 80 seconds!</p></strong></a
        >
      </li>
      <li>
        <a
          href="https://ericpolley.github.io/CharacterSheet-Fungeon-wip-01/"
          title="1st Version"
          target="_blank"
          rel="noopener noreferrer" 
        >
          <strong><p>The first version Character Sheet to see daylight #WIP</p></strong></a
        >
      </li>
      <li>
        <a
          href="http://ericpolley.com"
          title="My website"
          target="_blank"
          rel="noopener noreferrer" 
        >
          <strong><p>Check out my website</p></strong></a
        >
      </li>
    </ul>
  </section>
  )
}
